<template>
  <div class="container marketplace" v-if="product">
    <nav class="breadcrumbs mb-3">
      <router-link to="/marketplace">Главная</router-link>
      <span>›</span>
      <router-link
        v-if="product?.category"
        :to="{
          name: 'Marketplace',
          query: { category__in: product.category.id },
        }"
      >
        {{ product.category.name }}
      </router-link>
    </nav>

    <h1 class="d-none d-md-block">{{ product.name }}</h1>
    <div class="d-flex gap-4">
      <p class="article"><span>Артикул: </span>{{ product.sku_article }}</p>
      <div class="rating">
        <span v-if="!product.rating" class="stars me-2">★</span>
        <span v-for="star in product.rating" :key="star" class="stars me-2"
          >★</span
        >
        <span class="ms-2">{{
          product.rating > 0 ? product.rating : "Нет отзывов"
        }}</span>
      </div>
    </div>
    <div class="divider"></div>
    <div class="marketplace-header d-lg-flex mt-md-4 md-0 pt-0 d-md-block">
      <div>
        <div class="marketplace-image">
          <img :src="mainImg" alt="Product Image" />
        </div>

        <div class="marketplace-details gy-2 gap-3">
          <img
            class="small_imgs"
            v-for="(img, index) in product.images"
            :key="index"
            :src="img.image"
            @click="mainImg = img.image"
            alt="Product Image"
          />
        </div>
      </div>
      <div class="my-carousel">
        <Swiper
          :slides-per-view="1"
          :space-between="10"
          :pagination="{ clickable: true }"
          loop
          autoplay
          :modules="[Pagination, Autoplay]"
        >
          <SwiperSlide v-for="(img, index) in product.images" :key="index">
            <img :src="img.image" alt="slide image" class="swiper-slide-img" />
          </SwiperSlide>
          <div class="swiper-pagination"></div>
          <div class="swiper-button-next"></div>
          <div class="swiper-button-prev"></div>
        </Swiper>
      </div>
      <div class="marketplace-info mt-md-0 mx-4">
        <h2 class="marketplace-price">
          <template v-if="product.sale_price">{{
            formatPrice(product.sale_price)
          }}</template
          ><span class="ms-2" :class="product.sale_price ? 'sale' : ''">{{
            formatPrice(product.price)
          }}</span>
        </h2>
        <div
          class="quantity-control d-flex align-items-center gap-2 my-3 justify-content-between"
        >
          <label class="me-2">Количество</label>
          <div class="quantity-box d-flex align-items-center">
            <button @click="decreaseQuantity" class="qty-btn">−</button>
            <input
              type="number"
              class="qty-input"
              v-model.number="quantity"
              min="1"
            />
            <button @click="increaseQuantity" class="qty-btn">+</button>
          </div>
        </div>

        <h3 class="d-md-none d-block">{{ product.name }}</h3>
        <h3>О товаре</h3>
        <table class="marketplace-specs">
          <tr>
            <td><span>Тип</span></td>
            <td>{{ product.category?.name }}</td>
          </tr>
          <tr v-if="product.entrepreneur_name">
            <td><span>ИП</span></td>
            <td>{{ product?.entrepreneur_name }}</td>
          </tr>
          <!-- <tr>
            <td>Состав</td>
            <td></td>
          </tr>
          <tr>
            <td>Размер</td>
            <td></td>
          </tr>
          <tr>
            <td>Объем</td>
            <td></td>
          </tr>
          <tr>
            <td>Материал</td>
            <td></td>
          </tr>
          <tr>
            <td>Декоративные элементы</td>
            <td></td>
          </tr> -->
        </table>
      </div>
      <div class="col mt-md-0 mt-4">
        <div class="mobile-buttons">
          <!-- <button
            class="primary-button black-button mt-3 mr-3 w-100"
            :disabled="productAdded"
            @click.stop="addToCart"
          >
            {{ productAdded ? "В корзине" : "Добавить в корзину" }}
          </button> -->
          <!-- <button
            class="primary-button black-button mt-3 w-100"
            @click.stop="createChat"
          >
            Написать продавцу
          </button> -->
        </div>
        <div class="marketplace-card d-none">
          <div class="d-flex justify-content-between">
            <h3 class="marketplace-price">
              <template v-if="product.sale_price">{{
                formatPrice(product.sale_price)
              }}</template
              ><span class="ms-2" :class="product.sale_price ? 'sale' : ''">{{
                formatPrice(product.price)
              }}</span>
            </h3>
            <button
              @click="clickLike"
              class="like-button"
              :class="{ liked: likedProduct === true }"
            >
              <svg
                width="35"
                height="30"
                viewBox="0 0 16 15"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M7.18054 13.5549L7.17983 13.5542C5.11017 11.6365 3.43202 10.0786 2.26545 8.62023C1.10468 7.16915 0.5 5.8759 0.5 4.49591C0.5 2.23655 2.22166 0.5 4.4 0.5C5.6368 0.5 6.83521 1.09095 7.61714 2.02186L8 2.47767L8.38286 2.02186C9.16479 1.09095 10.3632 0.5 11.6 0.5C13.7783 0.5 15.5 2.23655 15.5 4.49591C15.5 5.8759 14.8953 7.16915 13.7346 8.62023C12.568 10.0786 10.8898 11.6365 8.82017 13.5542L8.81946 13.5549L8 14.3171L7.18054 13.5549Z"
                  stroke="#313132"
                />
              </svg>
            </button>
          </div>
          <!-- <button
            class="primary-button black-button mt-3 me-3 w-50"
            :disabled="productAdded"
            @click.stop="addToCart"
          >
            {{ productAdded ? "В корзине" : "Добавить в корзину" }}
          </button> -->
          <!-- <button
            class="primary-button black-button mt-3 w-50"
            @click.stop="createChat"
          >
            Написать продавцу
          </button> -->
        </div>
        <div class="marketplace-card col" v-if="product.company">
          <div
            class="seller-info d-flex flex-column justify-content-between gap-4"
          >
            <div class="h3 mb-0">{{ product.company_name }}</div>
            <div class="verified">
              <img src="@/assets/images/icons/verified.svg" />Проверен X-Global
            </div>
            <div class="article"><span>ИНН: </span>{{ company?.inn }}</div>

            <button class="lightblue-button" @click="goToCompany(company.inn)">
              <img src="@/assets/images/icons/showcase.svg" />
              Витрина продавца
            </button>
            <button
              class="lightblue-button"
              @click="goToCounterParties(company.inn)"
            >
              <img src="@/assets/images/icons/check-search.svg" />
              Проверить компанию
            </button>
          </div>
        </div>
        <button
          class="primary-button lightgreen-button mt-3 me-3 w-100"
          :disabled="productAdded"
          @click.stop="addToCart"
        >
          {{ productAdded ? "В корзине" : "Добавить в корзину" }}
        </button>
        <button
          class="primary-button green-button mt-3 w-100"
          @click="goToCounterParties()"
        >
          Перейти в компанию
        </button>
        <button
          class="primary-button green-button mt-3 w-100"
          @click.stop="createChat"
        >
          Написать продавцу
        </button>
      </div>
    </div>

    <div class="marketplace-tabs mt-4 mb-4">
      <span
        class="tab"
        :class="{ active: activeTab === 'description' }"
        @click="activeTab = 'description'"
      >
        Описание
      </span>
      <span
        class="tab"
        :class="{ active: activeTab === 'specs' }"
        @click="activeTab = 'specs'"
      >
        Характеристика
      </span>
      <span
        class="tab"
        :class="{ active: activeTab === 'reviews' }"
        @click="activeTab = 'reviews'"
      >
        Отзывы
      </span>
      <!-- <span
        class="tab"
        :class="{ active: activeTab === 'similar' }"
        @click="activeTab = 'similar'"
      >
        Похожие товары
      </span> -->
    </div>
    <div
      class="marketplace-description mt-4"
      v-show="activeTab === 'description'"
    >
      <h3>Описание</h3>
      <p class="mt-4" v-html="product.description"></p>
    </div>

    <div class="marketplace-specs-section mt-4" v-show="activeTab === 'specs'">
      <div class="specs">
        <h3>Характеристика</h3>
        <table class="custom-specs-table mt-4 w-100">
          <tr>
            <td>Артикул</td>
            <td></td>
          </tr>
          <tr>
            <td>Тип товара</td>
            <td>{{ product.category?.name }}</td>
          </tr>
          <tr>
            <td>Производитель</td>
            <td>{{ product.company_name }}</td>
          </tr>
          <tr>
            <td>Материал</td>
            <td></td>
          </tr>
        </table>
      </div>
      <!-- <div class="seller-details col-md-6 mb-4 mt-md-0 mt-4">
        <h3>О продавце</h3>
        <table class="mt-4 w-100">
          <tr>
            <td>Название</td>
            <td>{{ company?.name }}</td>
          </tr>
          <tr>
            <td>Генеральный директор</td>
            <td>{{ company?.directors[0]?.fio }}</td>
          </tr>
          <tr>
            <td>ОГРН</td>
            <td>{{ company?.ogrn }}</td>
          </tr>
          <tr>
            <td>ИНН</td>
            <td>{{ company?.inn }}</td>
          </tr>
          <tr>
            <td>Адрес</td>
            <td>{{ company?.legal_adress?.adress }}</td>
          </tr>
        </table>
      </div> -->
    </div>

    <div class="reviews-section" v-show="activeTab === 'reviews'">
      <template v-if="product?.comments.length">
        <div
          class="review d-flex"
          v-for="comment in product.comments"
          :key="comment.id"
        >
          <img :src="comment.user.avatar" alt="avatar" class="review-avatar" />
          <div class="ms-3">
            <div class="d-flex">
              <p class="review-author bold-text">
                {{ comment.user.full_name }}
              </p>

              <div class="review-rating ms-2">
                <span
                  v-for="star in comment.stars"
                  :key="star"
                  class="stars me-2"
                  >★</span
                >
              </div>
            </div>
            <p class="review-date">{{ formatDate(comment.time_create) }}</p>
            <p class="review-text">{{ comment.content }}</p>
          </div>
        </div>
      </template>
      <template v-else> Нет отзывов </template>
    </div>
    <!-- <div class="similar-section" v-show="activeTab === 'similar'">
      <h3>Похожие товары</h3>
      <div
        class="product-list grid gap-4 grid-cols-1 md:grid-cols-2 xl:grid-cols-3"
      >
        <NewProductCard
          v-for="item in similarProducts"
          :key="item.id"
          :product="item"
        />
      </div>
    </div> -->
  </div>
</template>

<script>
import { defineComponent, onMounted, ref, computed } from "vue";
import MarketplaceService from "@/services/marketplace";
import CompanyService from "@/services/company";
import ChatRoomService from "@/services/chatRoom";
import { useRoute, useRouter } from "vue-router";
import { useStore } from "vuex";
import moment from "moment";

// import { Swiper, SwiperSlide } from "swiper/vue"; // Correct path for Swiper 8+
import { Swiper, SwiperSlide } from "swiper/vue/swiper-vue";
import "swiper/swiper-bundle.css";
import "swiper/swiper.min.css";

import "swiper/modules/navigation/navigation.min.css";
import "swiper/modules/pagination/pagination.min.css";
import { Pagination, Navigation, Autoplay } from "swiper";
import { Modal } from "bootstrap";
// import NewProductCard from "@/components/Marketplace/NewProductCard.vue";

export default defineComponent({
  name: "MarketplaceItem",
  components: {
    Swiper,
    SwiperSlide,
    // NewProductCard,
    // Pagination,
    // Navigation,
    // Autoplay,
  },
  setup() {
    const store = useStore();
    const route = useRoute();
    const router = useRouter();
    const product = ref(null);
    const company = ref(null);
    const entrepreneur = ref(null);
    const productAdded = ref(false);
    const mainImg = ref(null);

    const likedProduct = ref(false);
    const selectRating = ref(0);
    const commentText = ref("");
    const parentComment = ref(null);
    const isLoggedIn = computed(() => store.state.auth.status.loggedIn);
    const activeTab = ref("description"); // description | specs | reviews
    // const similarProducts = computed(() =>
    //   products.value.filter(
    //     (p) =>
    //       p.id !== product.value?.id &&
    //       p.category?.id === product.value?.category?.id
    //   )
    // );
    const similarProducts = ref([]);
    const quantity = ref(1);

    const increaseQuantity = () => {
      quantity.value++;
    };

    const decreaseQuantity = () => {
      if (quantity.value > 1) quantity.value--;
    };

    const loadSimilar = async () => {
      const all = await MarketplaceService.loadProducts(); // загрузка всех

      if (product.value && product.value.category?.id) {
        similarProducts.value = all.filter(
          (p) =>
            p.category?.id === product.value.category.id &&
            p.id !== product.value.id
        );
      }
    };

    const clickLike = async () => {
      if (isLoggedIn.value) {
        if (!likedProduct.value) {
          await MarketplaceService.addToFavorite(product.value.id);
          likedProduct.value = true;
        } else {
          await MarketplaceService.removeFromFavorite(product.value.id);
          likedProduct.value = false;
        }
      } else {
        openModal();
      }
    };

    const sendComment = () => {
      if (
        (selectRating.value !== 0 || parentComment.value) &&
        commentText.value !== ""
      ) {
        MarketplaceService.sendComment(
          selectRating.value,
          commentText.value,
          product.value.id,
          parentComment.value
        );
        MarketplaceService.show(route.params.id).then((res) => {
          product.value = res;
        });
      }
    };

    const createChat = async () => {
      if (isLoggedIn.value) {
        const room = await ChatRoomService.addRoom({
          product: product.value.id,
        });
        store.dispatch("chats/SelectChat", {
          selectId: room.id,
          selectSlug: room.slug,
        });

        router.push("/profile/messages");
      } else {
        openModal();
      }
    };

    const addToCart = async () => {
      if (isLoggedIn.value) {
        await MarketplaceService.addToBasket(product.value.id, quantity.value);
        store.dispatch("user/getCartItems");

        productAdded.value = true;
        setTimeout(() => {
          productAdded.value = false;
        }, 1000);
      } else {
        openModal();
      }
    };

    const openModal = () => {
      const loginModal = new Modal(document.getElementById("authModal"));

      loginModal.show();
    };

    const goToCompany = () => {
      router.push({
        name: "Company",
        params: { id: product.value.company },
      });
    };

    const goToCounterParties = () => {
      router.push({
        name: "CounterParties",
        params: { id: company?.value?.inn || entrepreneur?.value?.inn },
      });
    };

    const formatPrice = (price) => {
      return new Intl.NumberFormat("ru-RU", {
        style: "currency",
        currency: "RUB",
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      }).format(price);
    };

    onMounted(async () => {
      await MarketplaceService.show(route.params.id).then((res) => {
        product.value = res;
        likedProduct.value = product.value.is_liked;
        if (product.value.images?.length) {
          mainImg.value = product.value.images[0]?.image;
        } else {
          mainImg.value = require("@/assets/images/logo_x.svg");
        }
      });
      if (product.value) {
        const companyId = product.value.company;
        const entrepreneurId = product.value.entrepreneur;
        if (companyId) {
          company.value = await store.dispatch("companies/getById", companyId);
        }
        if (entrepreneurId) {
          await CompanyService.getEntrepreneurs().then((res) => {
            entrepreneur.value = res.result.filter(
              (entrepreneur) => entrepreneur.id === entrepreneurId
            )[0];
          });
        }
      }

      if (product.value) {
        await loadSimilar(); // ⬅️ подгрузим похожие
      }
    });

    const formatDate = (date) => {
      return moment(date).format("DD.MM.YYYY");
    };

    return {
      company,
      entrepreneur,
      product,
      likedProduct,
      productAdded,
      mainImg,
      activeTab,
      similarProducts,
      quantity,
      goToCompany,
      addToCart,
      clickLike,
      sendComment,
      formatDate,
      createChat,
      formatPrice,
      goToCounterParties,
      increaseQuantity,
      decreaseQuantity,
      Pagination,
      Navigation,
      Autoplay,
    };
  },
});
</script>

<style scoped lang="scss">
@import "@/assets/styles/marketplace.scss";

.swiper-slide-img {
  width: 100%;
  height: 20rem;
  object-fit: contain;
}
.swiper-button-next {
  color: #3e3e3e;

  &::after {
    content: "";
    color: #3e3e3e;
    font-size: 20px;
    border-color: #3e3e3e;
  }
}

.swiper-button-prev {
  color: #3e3e3e;

  &::after {
    content: "";
    color: #3e3e3e;
    font-size: 20px;
    border-color: #3e3e3e;
  }
}
.marketplace-tabs {
  display: flex;
  overflow-x: auto;
  .tab {
    cursor: pointer;
    padding: 8px 16px;
    border-bottom: 2px solid rgba(229, 229, 229, 1);
    color: rgba(62, 62, 62, 1);
    font-weight: 400;
    font-size: 18px;
  }

  .tab.active {
    color: rgba(0, 199, 130, 1);
    border-color: rgba(0, 199, 130, 1);
  }
}
.custom-specs-table {
  border-collapse: separate;
  border-spacing: 0;
  overflow: hidden;

  tr {
    background-color: #f9f9f9;

    &:nth-child(odd) {
      background-color: #ffffff;
    }

    &:nth-child(even) {
      td:last-child {
        border-radius: 0 10px 10px 0;
      }
      td:first-child {
        border-radius: 10px 0 0 10px;
      }
    }
    &:last-child td:first-child {
      border-radius: 10px 0 0 10px;
    }
    &:last-child td:last-child {
      border-radius: 0 10px 10px 0;
    }

    td {
      padding: 12px 16px;
      font-size: 15px;
      color: #3e3e3e;

      &:first-child {
        color: rgba(62, 62, 62, 0.6);
      }

      &:last-child {
        color: rgba(62, 62, 62, 1);
      }
    }
  }
}
.article {
  font-size: 18px;
  color: rgba(62, 62, 62, 1);
  span {
    color: rgba(62, 62, 62, 0.6);
  }
}
.breadcrumbs {
  font-size: 16px;
  color: rgba(62, 62, 62, 0.6);
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
  align-items: center;

  a {
    color: rgba(62, 62, 62, 0.6);
    text-decoration: none;

    &:hover {
      text-decoration: underline;
      color: #00a367;
    }
  }

  span {
    color: rgba(62, 62, 62, 0.4);
  }
}
.quantity-box {
  background: #f6f6f6;
  border-radius: 12px;
  overflow: hidden;

  .qty-btn {
    background: none;
    border: none;
    padding: 8px 12px;
    font-size: 20px;
    cursor: pointer;
    color: #000;
  }

  .qty-input {
    width: 60px;
    text-align: center;
    border: none;
    background: transparent;
    font-size: 16px;
    outline: none;
  }
}
@media (max-width: 768px) {
  .marketplace-description,
  .marketplace-specs-section,
  .reviews-section {
    padding: 10px;
  }
}
</style>
